(function () {
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {

        $stateProvider
            .state('trafficOriginDestiny', {
                parent: 'app',
                url: '/trafficOriginDestiny',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/statistics/trafficOriginDestiny.html',
                        controller: 'trafficController',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['statistics']);
                            }],
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabStatistics('trafficOriginDestiny')
                            }],
                            type: [function () {
                                return 'trafficOriginDestiny';
                            }]
                        }
                    }
                }
            })
            .state('trafficByStages', {
                parent: 'app',
                url: '/trafficByStages',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/statistics/trafficByStages.html',
                        controller: 'trafficController',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['statistics']);
                            }],
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabStatistics('trafficByStages')
                            }],
                            type: [function () {
                                return 'trafficByStages';
                            }]
                        }
                    }
                }
            });

    }
})();
